import React from 'react';

export default function Map() {
  return (
    <div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d160446.5889558739!2d78.202387!3d17.504771!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf34997317791%3A0xd4f9f11c8b1f181b!2sAURA%20Tranquillo!5e1!3m2!1sen!2sin!4v1760684987050!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy" title='aura by tranquillo'
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
